import { AppState } from '../../rootReducer';

export const getError = (state: AppState) => state.emailMarketing.error;
